<template>
  <div id="app">
    <Navbar />
    <transition name="page" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
  </div>
</template>

<script>
import Navbar from '@/components/common/Navbar.vue'
import { authApi } from '@/api/auth'

export default {
  name: 'App',
  components: { Navbar },
  async created () {
    const saved = localStorage.getItem('jlpt_theme') || 'light'
    document.documentElement.setAttribute('data-theme', saved)

    // 已登录时刷新用户信息，同步最新订阅状态
    if (this.$store.getters['auth/isLoggedIn']) {
      try {
        const res = await authApi.getMe()
        const freshStatus = res.data.subscriptionStatus
        const cachedStatus = this.$store.getters['auth/subscriptionStatus']
        if (freshStatus !== cachedStatus) {
          // 订阅状态已变更（如管理员刚审批通过），重新获取含新 claim 的 Token
          await this.$store.dispatch('auth/refreshSubscription')
        } else {
          this.$store.commit('auth/UPDATE_USER', res.data)
        }
      } catch {
        // 401 由 axios 拦截器统一处理；网络错误不清除登录状态
      }
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  background: var(--bg-primary);
}
</style>
